// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form[data-v-01758620] {\n  text-align: center;\n}\n.form a[data-v-01758620] {\n  text-decoration: none;\n}\n.margin-r-20[data-v-01758620] {\n  margin-right: 20px;\n}\n.margin-r-10[data-v-01758620] {\n  margin-right: 10px;\n}\n.margin-l-10[data-v-01758620] {\n  margin-left: 10px;\n}\n.inline-block-input[data-v-01758620] {\n  display: inline-block;\n  width: auto;\n}\n.inline-block-input .briq-input[data-v-01758620] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
